import { useFlag } from '~/components/Flag';
import { t, Translation } from '~/components/I18n';
import puzzle from '~/components/Icon/puzzle.png';
import { useMember } from '~/components/Member/Member.hooks';
import { useMissionGroup } from '~/components/Mission/Mission.hooks';
import { appliedVersion, isTargetVersion } from '~/components/Quick/Menu/QuickMenu.hooks';
import { QuickMenuItem, QuickMenuItemProps } from '~/components/Quick/Menu/QuickMenuItem';

export const MissionQuickMenuItem = (props: Partial<QuickMenuItemProps>) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const { hidden } = useFlag({
    name: 'MISSION',
    value: appliedVersion,
    disabled: !isTargetVersion,
  });

  const {
    data: { complete },
  } = useMissionGroup({ useErrorBoundary: false });

  const active = isLoggedIn && !hidden;
  const showDescription = isLoggedIn && complete.length > 0;
  return (
    <QuickMenuItem
      {...props}
      active={active}
      image={puzzle}
      label={t('citizen_quick_mission')}
      description={
        showDescription ? (
          <Translation name="citizen_quick_mission_status" options={[complete.length]} />
        ) : null
      }
    />
  );
};
